import {apiBaseUrl, API_ENDPOINT} from "./api-config";

const appVersion = 1.6;

export { apiBaseUrl, API_ENDPOINT, appVersion };
